export const sortDates = (policies, dateProperty1, dateProperty2) => {
  // Newest date comes first
  return policies.sort((a, b) => {
    if (dateProperty2) {
      return (
        new Date(b[dateProperty1][dateProperty2]) -
        new Date(a[dateProperty1][dateProperty2])
      );
    } else return new Date(b[dateProperty1]) - new Date(a[dateProperty1]);
  });
};
